import { config } from '../../config';
import { client } from '../http';

export interface MessageData {
  product_id: string;
  rep_id: string;
  project_id: string;
  message: string;
  message_source: string;
  manufacturer_sku: string;
  manufacturer: string;
  quick_topics: string[];
  product_name: string;
}

export const sendMessage = async (messageData: MessageData) => {
  try {
    const { data } = await client.post(
      config.endpoints.sendMessage,
      messageData,
    );
    return data;
  } catch (error) {
    console.log('error setMessage', error.message);
    throw error;
  }
};
